<template>
  <v-dialog width="620" v-model="dialog" persistent scrollable>
    <v-card>
      <v-card-title class="blue darken-4 white--text">
        <v-toolbar-title>THÊM PHÒNG KIỂM TRA</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-6 pt-0 pb-6">
        <v-form v-bind="this.$attrs" ref="form">
          <div>
            <div v-for="(room, index) in rooms" :key="index">
              <div class="pt-6">
                <div class="d-flex">
                  <div class="d-flex" style="flex-grow: 1">
                    <v-text-field
                      :label="`Tên phòng kiểm tra ${index + 1}`"
                      v-model="room.name"
                      outlined
                      style="flex-grow: 1"
                      class="pr-6 required"
                      required
                      :rules="[$rules.required]"
                    ></v-text-field>
                    <v-text-field
                      label="Mã phòng"
                      v-model="room.code"
                      outlined
                      style="flex-grow: 1"
                      class="pr-6 required"
                      required
                      :rules="[$rules.required]"
                    ></v-text-field>
                    <v-text-field
                      label="Buổi kiểm tra"
                      v-model="room.note"
                      outlined
                      style="flex-grow: 1"
                      class="pr-6 required"
                      required
                      :rules="[$rules.required]"
                    ></v-text-field>
                    <v-text-field
                      label="Số lượng"
                      v-model="room.capacity"
                      outlined
                      style="flex-grow: 1"
                      class="pr-6 required"
                      required
                      :rules="[$rules.number]"
                    ></v-text-field>

                    <div class="d-flex align-items-center justify-content-end pb-6">
                      <v-icon @click="removeRoom(index)">mdi-trash-can</v-icon>
                    </div>
                  </div>
                </div>
                <div>
                  <v-text-field
                    label="Địa điểm"
                    v-model="room.location"
                    outlined
                    class="required"
                    required
                    :rules="[$rules.required]"
                  ></v-text-field>
                </div>
                <div class="d-flex flex-wrap">
                  <div
                    v-for="(subjectGroup, groupIndex) in groupedSubjects"
                    :key="groupIndex"
                    class="d-flex"
                    style="width: 100%"
                  >
                    <div class="d-flex" style="width: 100%">
                      <v-checkbox
                        v-for="(subject, subjectIndex) in subjectGroup"
                        :key="subjectIndex"
                        v-model="room.subjects"
                        :label="subject.name"
                        :value="subject"
                        class="pt-0 mt-0 pb-6"
                        hide-details
                        style="flex-basis: 33%"
                      ></v-checkbox>
                    </div>
                  </div>
                </div>
              </div>

              <v-divider v-if="index < rooms.length - 1"></v-divider>
            </div>
            <div class="d-flex justify-space-between">
              <v-spacer></v-spacer>
              <v-btn outlined color="blue darken-4" @click="addRoom">Thêm phòng</v-btn>
            </div>
          </div>
        </v-form>
      </v-card-text>

      <v-divider> </v-divider>
      <v-card-actions class="pa-6">
        <v-btn color="blue darken-4" outlined @click="close">Hủy </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-4" dark @click="submit">Xác nhận</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { Room } from '@/plugins/api'
import { chunk } from 'lodash'
export default {
  props: {
    state: Boolean,
    subjects: Array
  },
  watch: {
    state(state) {
      this.dialog = state
      if (!state) this.loading = false
    },
    profile: {
      immediate: true,
      handler(newProfile) {
        if (newProfile) {
          this.setFormValues(newProfile)
        }
      }
    }
  },
  computed: {
    groupedSubjects() {
      return chunk(this.subjects, 3)
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      rooms: [
        {
          name: '',
          code: '',
          location: '',
          note: '',
          capacity: 0,
          subjects: [],
          exam: this.$route.params.id
        }
      ]
    }
  },
  methods: {
    close() {
      this.$emit('closeDialog')
      this.$refs.form.resetValidation()
    },
    addRoom() {
      this.rooms.push({
        name: '',
        code: '',
        location: '',
        capacity: 0,
        subjects: [],
        exam: this.$route.params.id
      })
    },
    removeRoom(index) {
      if (this.rooms.length <= 1) {
        this.$set(this.rooms, 0, {
          name: '',
          code: '',
          location: '',
          note: '',
          capacity: 0,
          subjects: [],
          exam: this.$route.params.id
        })
      } else {
        this.rooms.splice(index, 1)
      }
    },
    isSubjectSelected(room, subjectId) {
      return room.subjects.includes(subjectId)
    },
    handleCheckboxChange(room, subjectId) {
      const index = room.subjects.indexOf(subjectId)
      if (index >= 0) {
        room.subjects.splice(index, 1)
      } else {
        room.subjects.push(subjectId)
      }
    },
    resetForm() {
      this.rooms = [
        {
          name: '',
          code: '',
          location: '',
          note: '',
          capacity: 0,
          subjects: [],
          exam: this.$route.params.id
        }
      ]
    },
    async submit() {
      if (this.$refs.form.validate()) {
        this.$loading.active = true
        const createRooms = await Room.createManyRooms({ exam: this.$route.params.id, rooms: this.rooms })
        if (createRooms) {
          this.$emit('refresh')
          this.resetForm()
          this.close()
        }
      }
    }
  }
}
</script>
